import { WeblogPageCategory, WeblogScreenName } from '../../../shared/constants/weblog';
import { sendClickLog } from '../../utils/sendClickLog';

import styled from '@emotion/styled';
import { resetButton } from '../../../styles/reset';
import Icon from '../../../shared/designSystem/components/Icon';
import { globalVariables } from '../../../shared/designSystem/constants';

type Props = {
  label: string;
  desc?: string;
  iconBaseUrl?: string;
  iconName?: string;
  link?: string;
  onClick?: () => void;
};

export default function ProfilePopupLink({
  label,
  desc,
  iconBaseUrl,
  iconName,
  link,
  onClick,
}: Props) {
  const handleClick = () => {
    if (link) {
      sendClickLog({
        eventName: 'topmenu',
        screenName: WeblogScreenName.COMMON,
        pageCategory: WeblogPageCategory.COMMON,
        itemKind: 'menu',
        itemName: label,
        targetUrl: link,
      });
    }

    onClick?.();
  };

  return (
    <Container href={link} onClick={handleClick}>
      {iconName && <LinkIcon baseUrl={iconBaseUrl} name={iconName} />}
      <LinkLabel>{label}</LinkLabel>
      {desc && <LinkDesc>{desc}</LinkDesc>}
    </Container>
  );
}

const Container = styled.a`
  ${resetButton};

  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 16px;
  font-size: 15px;
  font-weight: 500;

  &:hover {
    background-color: ${globalVariables.gray_60};
  }
`;

const LinkLabel = styled.span`
  color: ${globalVariables.gray_700};
`;

const LinkIcon = styled(Icon)`
  margin-right: 16px;
`;

const LinkDesc = styled.span`
  margin-left: auto;
  color: ${globalVariables.blue_500};
`;
